module.exports = new __parcel__URL__("orangeDark.992e5f46.jpg").toString();